import { RequisitesPage } from 'features/requisites';

export const OperatorPayinRequisitesPage: React.FC = () => <RequisitesPage />;
